import React, { useContext, useEffect } from 'react'
import { debounce } from 'lodash'
import { LOGO, SITE_NAME } from '../../../../utils/UI'
import { useHistory } from 'react-router-dom'
import Button from '@mui/material/Button'
import './Header.css'
import { Link } from 'react-router-dom'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import AuthContext from '../../../../product/context/auth/authContext'
import AlertContext from '../../../../product/context/alert/alertContext'
import SettingContext from '../../../../product/context/setting/settingContext'
import CommunicationContext from '../../../../product/context/communication/communicationContext'
import CartContext from '../../../../product/context/cart/cartContext'
import UserContext from '../../../../product/context/user/userContext'
import AuctionContext from '../../../../product/context/auction/auctionContext'
import ProductContext from '../../../../product/context/product/productContext'
import BidContext from '../../../../product/context/bid/bidContext'
import ReturnContext from '../../../../product/context/return/returnContext'
import AppointmentContext from '../../../../product/context/appointment/appointmentContext'

import { handleRedirectInternal } from '../../../../product/common/components'
import EmployeeContext from '../../../../product/context/employee/empContext'
import NewsContext from '../../../context/news/newsContext'
import LanguageManagerContext from '../../../../product/context/languageManager/languageManagerContext'
import BidHistory from '../../../components/organisms/BidHistory'
import TTWBidHistory from '../../../components/organisms/TTWBidHistory'
import DynamicContext from '../../../../product/context/dynamic/dynamicContext'
import InvoiceContext from '../../../../product/context/invoice/invoiceContext'
import AsinContext from '../../../context/thirdParty/asin/asinContext'
import OfferHistory from '@/product/components/organisms/OfferHistory'
import StripeCustomerContext from '@/product/context/stripe/customer/customerContext'
import ManifestContext from '@/product/context/manifest/manifestContext'
import useMediaQuery from '@mui/material/useMediaQuery'
{/* prettier-ignore */ }

const Header = (props) => {
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const communicationContext = useContext(CommunicationContext)
    const settingContext = useContext(SettingContext)
    const cartContext = useContext(CartContext)
    const returnContext = useContext(ReturnContext)
    const appointmentContext = useContext(AppointmentContext)
    const userContext = useContext(UserContext)
    const employeeContext = useContext(EmployeeContext)
    const newsContext = useContext(NewsContext)
    const auctionContext = useContext(AuctionContext)
    const productContext = useContext(ProductContext)
    const bidContext = useContext(BidContext)
    const dynamiccontext = useContext(DynamicContext)
    const invoiceContext = useContext(InvoiceContext)
    const asinContext = useContext(AsinContext)
    const stripeCustomerContext = useContext(StripeCustomerContext)
    const manifestContext = useContext(ManifestContext)
    const isMobile = useMediaQuery('(max-width:1024px)')
    const {
        responseStatus: responseStatusDynamic,
        clearResponse: clearResponseDynamic,
    } = dynamiccontext
    const languageManagerContext = useContext(LanguageManagerContext)

    const {
        clearResponse: clearResponseStatusInvoice,
        responseStatus: responseStatusInvoice,
    } = invoiceContext

    const {
        responseStatus: responseManifestUpload,
        clearResponse: clearManifestResponse,
    } = manifestContext || {}

    const {
        user,
        responseStatus: responseStatusAuth,
        clearResponse: clearResponseAuth,
        logout,
        updateProfile,
        loadUser,
    } = authContext
    const { setAlert } = alertContext

    const {
        responseStatus: responseStatusCommuncation,
        clearResponse: clearResponseCommuncation,
    } = communicationContext

    const {
        responseStatus: responseStatusReturn,
        clearResponse: clearResponseReturn,
    } = returnContext

    // const responseStatusReturn = null
    // const clearResponseReturn = () => {}
    const {
        responseStatus: responseStatusStripeCustomer,
        clearResponse: clearResponseStripeCustomer = () => {},
    } = stripeCustomerContext || {}
    const {
        responseStatus: responseStatusLanguageManager,
        clearResponse: clearResponseLanguageManager,
    } = languageManagerContext

    const {
        responseStatus: responseStatusAppointment,
        clearResponse: clearResponseAppointment,
    } = appointmentContext

    const {
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseSetting,
    } = settingContext

    const {
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = userContext

    const {
        responseStatus: responseStatusEmployee,
        clearResponse: clearResponseEmployee,
    } = employeeContext

    const {
        responseStatus: responseStatusNews,
        clearResponse: clearResponseNews,
    } = newsContext

    const {
        responseStatus: responseStatusAuction,
        clearResponse: clearResponseAuction,
    } = auctionContext

    const {
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
    } = productContext

    const {
        responseStatus: responseStatusBid,
        clearResponse: clearResponseBid,
    } = bidContext

    const {
        responseStatus: responseStatusCart,
        clearResponse: clearResponseCart,
    } = cartContext

    const { responseStatus: responseAsin, clearResponse: clearResponseAsin } =
        asinContext
    useEffect(() => {
        if (responseStatusStripeCustomer) {
            if (responseStatusStripeCustomer.status === 'success') {
                if (responseStatusStripeCustomer.from == 'create') {
                    updateProfile(
                        { stripe_id: responseStatusStripeCustomer.data.id },
                        false
                    )
                }
            }
        }
        clearResponseStripeCustomer()
    }, [responseStatusStripeCustomer])
    useEffect(() => {
        if (responseStatusAuth) {
            if (responseStatusAuth.from === 'updateProfile') {
                if (responseStatusAuth.status === 'success') {
                    loadUser()
                }
            } else {
                setAlert(responseStatusAuth.message, responseStatusAuth.status)
            }

            clearResponseAuth()
        }

        if (responseStatusCommuncation) {
            setAlert(
                responseStatusCommuncation.message,
                responseStatusCommuncation.status
            )
            clearResponseCommuncation()
        }
        if (responseStatusUser) {
            setAlert(responseStatusUser.message, responseStatusUser.status)
            clearResponseUser()
        }
        if (responseStatusEmployee) {
            setAlert(
                responseStatusEmployee.message,
                responseStatusEmployee.status
            )
            clearResponseEmployee()
        }
        if (responseStatusNews) {
            setAlert(responseStatusNews.message, responseStatusNews.status)
            clearResponseNews()
        }
        if (responseStatusAuction) {
            setAlert(
                responseStatusAuction.message,
                responseStatusAuction.status
            )
            clearResponseAuction()
        }
        if (responseStatusProduct) {
            setAlert(
                responseStatusProduct.message,
                responseStatusProduct.status
            )
            clearResponseProduct()
        }

        if (responseManifestUpload) {
            setAlert(
                responseManifestUpload.message,
                responseManifestUpload.status
            )
            clearManifestResponse()
        }

        if (responseStatusSetting) {
            setAlert(
                responseStatusSetting.message,
                responseStatusSetting.status
            )
            clearResponseSetting()
        }
        if (responseStatusCart) {
            setAlert(responseStatusCart.message, responseStatusCart.status)
            clearResponseCart()
        }

        if (responseStatusDynamic) {
            setAlert(
                responseStatusDynamic.message,
                responseStatusDynamic.status
            )
            clearResponseDynamic()
        }
        if (responseStatusLanguageManager) {
            setAlert(
                responseStatusLanguageManager.message,
                responseStatusLanguageManager.status
            )
            clearResponseLanguageManager()
        }
        if (responseStatusBid) {
            if (!responseStatusBid.noAlert) {
                setAlert(responseStatusBid.message, responseStatusBid.status)
            }
            clearResponseBid()
        }
        if (responseStatusReturn) {
            setAlert(responseStatusReturn.message, responseStatusReturn.status)
            clearResponseReturn()
        }

        if (responseStatusInvoice) {
            setAlert(
                responseStatusInvoice.message,
                responseStatusInvoice.status
            )
            clearResponseStatusInvoice()
        }

        if (responseStatusAppointment) {
            if (!responseStatusAppointment.noAlert) {
                setAlert(
                    responseStatusAppointment.message,
                    responseStatusAppointment.status
                )
            }
            clearResponseAppointment()
        }
        if (responseAsin) {
            setAlert(responseAsin.message, responseAsin.status)
            clearResponseAsin()
        }
    }, [
        responseStatusAuth,
        responseStatusCommuncation,
        responseStatusUser,
        responseStatusEmployee,
        responseStatusNews,
        responseStatusAuction,
        responseStatusProduct,
        responseStatusBid,
        responseStatusSetting,
        responseStatusCart,
        responseStatusDynamic,
        responseStatusLanguageManager,
        responseStatusReturn,
        responseStatusAppointment,
        responseStatusInvoice,
        responseManifestUpload,
        responseAsin,
    ])

    const history = useHistory()

    const debouncedSetAlert = debounce((message, type) => {
        setAlert(message, type)
    }, 300)

    const onLogOut = () => {
        logout()
        debouncedSetAlert('Logged out successfully', 'success')
        handleRedirectInternal(history, '')
    }

    return (
        <>
            {/* noUI props is being added to remove the default UI from the header and show everything on the Side Panel */}
            {props.noUI ? (
                <></>
            ) : (
                <>
                    <div className="header">
                        <div className="customContainer d-flex justify-content-between align-items-center smpCls">
                            <div className="headLogo">
                                <Link to="/dashboard" id={`${SITE_NAME}_logo`}>
                                    <img src={LOGO} alt={`${SITE_NAME} Logo`} />
                                </Link>
                            </div>
                            <div className="d-flex align-items-center flex-wrap">
                                {!isMobile && (
                                    <>
                                        <div className="activeSession d-none d-md-block">
                                            <span className="material-icons">
                                                info
                                            </span>
                                            <h6>User:</h6>
                                            <h6>
                                                {' '}
                                                {`${user.emp_firstname} ${user.emp_lastname}  `}
                                            </h6>
                                        </div>
                                        {process.env?.REACT_APP_OKTA_SIGNIN ===
                                        'true' ? (
                                            <> </>
                                        ) : (
                                            <div className="activeSession d-none d-md-block  mr-md-5 mr-lg-0">
                                                <span className="material-icons">
                                                    info
                                                </span>
                                                <h6>Active Session:</h6>
                                                <h6>
                                                    {' '}
                                                    {moment
                                                        .unix(
                                                            jwtDecode(
                                                                localStorage.getItem(
                                                                    'token'
                                                                )
                                                            ).exp
                                                        )
                                                        .format(
                                                            'MM/DD/YYYY h:mm a'
                                                        )}
                                                </h6>
                                            </div>
                                        )}
                                    </>
                                )}
                                <Button
                                    id="logout"
                                    className="logOut"
                                    onClick={() => onLogOut()}
                                    aria-controls="simple-menu"
                                    aria-haspopup="true"
                                >
                                    <span className="d-none d-block-md">
                                        Logout
                                    </span>
                                    <span className="material-icons">
                                        power_settings_new
                                    </span>
                                </Button>
                            </div>
                        </div>
                    </div>
                    {isMobile && (
                        <div className="mobileSession">
                            <div className="activeSession d-none d-md-block">
                                <span className="material-icons">info</span>
                                <h6>User:</h6>
                                <h6>
                                    {' '}
                                    {`${user.emp_firstname} ${user.emp_lastname}  `}
                                </h6>
                            </div>
                            {process.env?.REACT_APP_OKTA_SIGNIN === 'true' ? (
                                <> </>
                            ) : (
                                <div className="activeSession d-none d-md-block">
                                    <span className="material-icons">info</span>
                                    <h6>Active Session:</h6>
                                    <h6>
                                        {' '}
                                        {moment
                                            .unix(
                                                jwtDecode(
                                                    localStorage.getItem(
                                                        'token'
                                                    )
                                                ).exp
                                            )
                                            .format('MM/DD/YYYY h:mm a')}
                                    </h6>
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}
            <BidHistory project={props.project} />
            <OfferHistory project={props.project} />
            <TTWBidHistory />
        </>
    )
}

export default Header
